import React, { useRef } from 'react'
import PropTypes from 'prop-types'
import { 
  Button, 
  Card, 
  CardBody, 
  Col, 
  FormGroup, 
  UncontrolledTooltip 
} from "reactstrap"
import { AvField, AvForm } from "availity-reactstrap-validation"
import { useTranslation } from "react-i18next"

const DecoderForm = ({ 
  templateConfig, 
  onValidSubmit, 
  onDataChange, 
  onClear,
  buttonTimer, 
  dataLength, 
  showLengthBadge,
  currentHexValue
}) => {
  const { t } = useTranslation()
  const formRef = useRef(null)

  const handleKeyPress = (e) => {
    const char = e.key
    const isValidHex = /^[0-9A-Fa-f]$/.test(char)
    const isControlKey = ['Backspace', 'Delete', 'Tab', 'Enter', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'].includes(char)
    
    if (!isValidHex && !isControlKey && char.length === 1) {
      e.preventDefault()
    }
  }

  const handleClearClick = () => {
    if (formRef.current) {
      formRef.current.reset()
    }
    onClear()
  }

  const isCvmList = templateConfig.pageKey === 'cvmList'
  const colSize = isCvmList ? { lg: 6, md: 6 } : { lg: 3, md: 3 }

  return (
    <Col lg={colSize.lg} md={colSize.md}>
      <Card style={{ backgroundColor: 'transparent', border: 'none', boxShadow: 'none' }}>
        <CardBody style={{ paddingLeft: 0 }}>
          <AvForm ref={formRef} onValidSubmit={onValidSubmit}>
            <div className="rowAes">
              <div>
                <FormGroup>
                  <div className="position-relative">
                    <div className="position-absolute" style={{ top: '-25px', right: '5px', zIndex: 10 }}>
                      <div className="d-flex align-items-center gap-2">
                        {showLengthBadge && (
                          <span className="badgecount badge bg-success" style={{ fontSize: '0.75rem' }}>
                            {dataLength} {t(templateConfig.fieldConfig.lengthLabel)}
                          </span>
                        )}
                        <UncontrolledTooltip
                          placement="bottom"
                          target="Data"
                        >
                          {t(templateConfig.fieldConfig.tooltipText)}
                        </UncontrolledTooltip>
                        <i
                          className="dripicons-information"
                          id="Data"
                          style={{ cursor: 'pointer' }}
                        ></i>
                      </div>
                    </div>
                    <AvField
                      name="data"
                      placeholder={t(templateConfig.fieldConfig.placeholder)}
                      type="text"
                      className="form-control"
                      onChange={onDataChange}
                      onKeyPress={handleKeyPress}
                      value={currentHexValue || ''}
                      validate={{
                        pattern: { value: /^[0-9A-Fa-f]+$/ },
                        required: { value: true },
                        minLength: { value: templateConfig.fieldConfig.validation.min },
                        maxLength: { value: templateConfig.fieldConfig.validation.max }
                      }}
                    />
                  </div>
                  <div className="d-flex justify-content-end gap-2" style={{paddingTop: 10}}>
                    <Button
                      onClick={handleClearClick}
                      color="secondary"
                    >
                      {t("clearButton")}
                    </Button>
                    <Button
                      type="submit"
                      disabled={buttonTimer}
                      color="primary"
                    >
                      {t("decodeButton")}
                    </Button>
                  </div>
                </FormGroup>
              </div>
            </div>
          </AvForm>
        </CardBody>
      </Card>
    </Col>
  )
}

DecoderForm.propTypes = {
  templateConfig: PropTypes.object.isRequired,
  onValidSubmit: PropTypes.func.isRequired,
  onDataChange: PropTypes.func.isRequired,
  onClear: PropTypes.func.isRequired,
  buttonTimer: PropTypes.bool.isRequired,
  dataLength: PropTypes.number,
  showLengthBadge: PropTypes.bool,
  currentHexValue: PropTypes.string,
}

export default DecoderForm
